import { adminHttpClient } from '../commons/adminHttpClient'

export interface ExpenseCategory {
  id: number
  name: string
  icon: string
}

const getUserAvailableExpenseCategories = (periodId: string): Promise<ExpenseCategory[]> => {
  return adminHttpClient.get(`/Expenses/UserAvailableExpenseCategories/${periodId}`)
}

export default getUserAvailableExpenseCategories
